export default function createLookup(list, key, resolver) {
    return list.reduce((lookup, item) => {
        // @ts-ignore
        lookup[key ? item[key] : item] = resolver ? resolver(item) : true;
        return lookup;
    }, {});
}
